import axios from "axios";
import api from "../api";

const token = localStorage.getItem("auth") === null ? null : JSON.parse(localStorage.getItem("auth")).accessToken
const userId = localStorage.getItem("auth") === null ? null : JSON.parse(localStorage.getItem("auth")).userId
const language = localStorage.getItem("language") === null ? "tr" : localStorage.getItem("language")
const header = { headers: { "Authorization": `Bearer ${token}`, "Accept-Language": language } }

export function LoginService(userName, password) {
    return axios.post(api.LOGIN, { "userName": userName, "password": password }, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ModuleCreateService(file, site, name, slug) {
    const formData = new FormData()
    if (file !== null && file !== undefined && file.length > 0) {
        file.forEach(element => {
            formData.append("file", element)
        });
    }
    formData.append("site", site)
    formData.append("name", name)
    formData.append("slug", slug)
    formData.append("userId", userId)

    return axios.post(api.LOGIN, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}